//////////////////////////////////////////////

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import router from '@/router'
import store from '@/store/index.js'
import axios from "axios";
import "@/assets/css/main.css";
import "@/assets/css/tailwind.css";
// import { api } from '@/hooks/axios-api';


//axios defaults
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

if (document.location.toString().indexOf("cms.staging.alignd.co.za") > -1) {
  axios.defaults.baseURL = "https://api.staging.alignd.co.za";
}

axios.interceptors.request.use(
  async (request) => {
    if (store.getters["login/isLoggedIn"] && !request.url.includes("login")) {
      request.headers.Authorization = "Token " + localStorage.getItem("token");
    }
    return request;
  },
  function (err) {
    return new Promise<void>(function (resolve, reject) {
      if (err.status === 401 && err.config) {
        store.dispatch("login/logoutUser");
        store.dispatch("login/authError");
        resolve();
      }
      reject(err);
      throw err;
    });
  }
);

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(store)
app.use(VueQueryPlugin)
app.use(router)
app.mount('#app')
